import { gql } from "@apollo/client";

export const GET_PACIENTE_PROBABLE_PAGINATED = gql`
query GetAllPrePaciente(
    $skip: Int
    $take: Int
    $where: PrePacienteFilterInput
    $order: [PrePacienteSortInput!]
) {
    allPrePaciente(skip: $skip, take: $take, where: $where, order: $order)
    {
        items {
            idDelegacion
            codInstitucion
            nombre
            apellido
            idEstado
            idPrePaciente
            fechaAlta
            fechaAltaProbable
            codInstitucionNavigation {
                nombre
                cod_Institucion
            }
            idDelegacionNavigation {
                descripcion
            }
            idTipoModuloNavigation {
                abreviacion
            }
            idUsuarioAltaNavigation {
                apellido
                nombre
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;